<header class="bg-cmaxhm-blue">
  <div class="flex justify-between md:justify-start">
    <h1>
      <a [routerLink]="['/']"><img src="./assets/images/cmaxhm-logo.svg" alt="Cmaxhm"></a>
    </h1>
    <nav #navigationMenu class="absolute z-10 top-14 hidden w-full bg-cmaxhm-blue transition-all md:ml-5 md:static md:block">
      <ul class="h-full items-center md:flex">
        <li class="h-full flex items-center" *ngFor="let navigationMenuItem of navigationMenuItems">
          <a
            class="w-full h-full p-4 flex text-white items-center transition-all md:py-0"
            routerLinkActive="border-b-2 border-b-white"
            [routerLink]="navigationMenuItem.url"
            [routerLinkActiveOptions]="{ exact: true }"
            (click)="onHideNavigationMenu()"
          >{{ navigationMenuItem.label }}</a>
        </li>
      </ul>
    </nav>
    <button #navigationButton class="px-4 md:hidden transition-all" (click)="toggleNavigationMenu()">
      <img src="./assets/images/hamburger-menu.svg" width="30" alt="Menu">
    </button>
  </div>
</header>
